import { render, staticRenderFns } from "./RNAFormulation.vue?vue&type=template&id=8982e8a4&scoped=true&lang=pug&"
import script from "./RNAFormulation.vue?vue&type=script&lang=js&"
export * from "./RNAFormulation.vue?vue&type=script&lang=js&"
import style0 from "./RNAFormulation.vue?vue&type=style&index=0&id=8982e8a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8982e8a4",
  null
  
)

export default component.exports